import styles from "./page-heading.module.scss";

const PageHeading = ({title, subtitle, children}) => {
    return (
        <div className={styles.heading}>
            <div className={styles.titleWrapper}>
                <h1 className={styles.title}>{title}</h1>
                <h2 className={styles.subtitle}>{subtitle}</h2>
            </div>
            <div className={styles.box}>
                {children}
            </div>
        </div>
    )
}

export default PageHeading;